// extracted by mini-css-extract-plugin
export var active = "_bu-2";
export var recordingDot = "_bu-1";
export var recordingIndicator = "_bu-0";